import { memo } from 'react';

import Icon from '@ui/icons/icon';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import Switch from '@ui/switch/switch';
import { SignInOption } from './sign-in-option-types';
import Text from '@ui/text/text/text';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import { deriveRegistrationUpdate } from '../../../helpers/derive-registration-update';
import SettingsEditPanel from '../../../../../controls/settings-edit-panel';
import SignInOptionDisplayPosition from './sign-in-option-display-position';

const RenderSignInOption = memo(
  ({ option, registrationSettings }: { option: SignInOption; registrationSettings?: Registration }) => {
    const value = option.uuid ?? option.type;
    const isOn = registrationSettings?.singleSignOn?.singleSignOns?.includes(value) ?? false;

    const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);
    const dispatch = useAppDispatch();

    const handleToggleSignInOption = (provider: string, on: boolean) => {
      if (!registrationSettings) return;
      const update = deriveRegistrationUpdate(
        { registration_settings: registrationSettings },
        { kind: 'social-signin', provider, on },
        []
      );
      dispatch(saveWorkingProjectByFields(update));
    };

    return (
      <SettingsEditPanel
        isEditing={isOn}
        expandContent={
          <Container className="padding-t-16 padding-b-6">
            <SignInOptionDisplayPosition registrationSettings={registrationSettings} />
          </Container>
        }
      >
        <Container className="flex fd-row jc-space-between ai-center">
          <div className="flex ai-center gap-8">
            <Container className="square-32 flex fd-column ai-center jc-center" design="GlobalCont2" borderRadius="8px">
              {!!option.icon && <Icon size={12} name={option.icon} />}
            </Container>
            <Text tag="h6" className="H6" clamp={1}>
              Sign in with {option.label}
            </Text>
          </div>
          <Switch disabled={savingWorkingProject} value={value} on={isOn} onClick={handleToggleSignInOption} />
        </Container>
      </SettingsEditPanel>
    );
  }
);

RenderSignInOption.displayName = 'RenderSignInOption';

export default RenderSignInOption;
